import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { EmojiEvents as TrophyIcon, ArrowForward as ArrowIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import HomeSection from "./HomeSection";
import { homeCardHover } from "./homeStyles";
import { brandOutlinedButtonSx } from "../../utils/brandAssets";

const NbaAllTimeGreatsEntry = () => {
  const navigate = useNavigate();

  return (
    <HomeSection title="All-time greats" subtitle="Career leaders across every era">
      <Box
        onClick={() => navigate("/app/nba/all-time-greats")}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          ...homeCardHover,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(245, 158, 11, 0.15)",
            }}
          >
            <TrophyIcon sx={{ color: "#f59e0b", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="body1" fontWeight={600}>
              Explore NBA legends
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Points, rebounds, assists, steals, blocks, and PPG — the full
              career leaderboard.
            </Typography>
          </Box>
        </Box>
        <Button
          variant="outlined"
          endIcon={<ArrowIcon />}
          onClick={(event) => {
            event.stopPropagation();
            navigate("/app/nba/all-time-greats");
          }}
          sx={brandOutlinedButtonSx}
        >
          View leaders
        </Button>
      </Box>
    </HomeSection>
  );
};

export default NbaAllTimeGreatsEntry;
